const rangeGenerator = function (start, end, step = 10) {
  const len = Math.floor((end - start) / step) + 1
  return Array(len).fill().map((_, idx) => start + (idx * step))
}

export default rangeGenerator
